import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const CurrentImageRender = ({ filename, refreshKey }) => {
  const [imageError, setImageError] = useState(false);
  const [imageKey, setImageKey] = useState(refreshKey || Date.now());
  
  // Update imageKey when refreshKey changes to force image reload with 3 second delay
  React.useEffect(() => {
    if (refreshKey) {
      const timer = setTimeout(() => {
        setImageKey(refreshKey);
        setImageError(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [refreshKey]);
  
  // Construct CloudFront URL with cache-busting parameter
  const imageUrl = `https://dp9h3awfnhccl.cloudfront.net/magazines/${filename}?t=${imageKey}`;

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageError(false);
  };

  const handleReload = () => {
    setImageKey(Date.now());
    setImageError(false);
  };

  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', mb: 0.5, display: 'block' }}>
        Current Image:
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        {!imageError ? (
          <Box
            key={imageKey}
            component="img"
            src={imageUrl}
            alt={`Magazine cover: ${filename}`}
            onError={handleImageError}
            onLoad={handleImageLoad}
            sx={{
              width: '100%',
              maxWidth: '150px',
              height: 'auto',
              borderRadius: '8px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              display: 'block',
              '&:hover': {
                border: '2px solid rgba(255, 107, 53, 0.6)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              }
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              maxWidth: '150px',
              height: '100px',
              borderRadius: '8px',
              border: '2px dashed rgba(255, 107, 53, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0,0,0,0.1)',
            }}
          >
            <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', textAlign: 'center', px: 2 }}>
              Image not found
            </Typography>
          </Box>
        )}
        <Tooltip title="Reload image">
          <IconButton
            size="small"
            onClick={handleReload}
            sx={{
              color: '#06AED5',
              p: 0.5,
              '&:hover': {
                background: 'rgba(6, 174, 213, 0.1)',
              },
            }}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default CurrentImageRender;
